import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import BoucleView from '../views/LoopView.vue'
import ChallengeView from '../views/ChallengeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/challenge/12_heures',
    component: HomeView,
    meta: {
      title: 'Golden Backyard - Accueil'
    }
  },
  {
    path: '/challenge/:challenge_uuid/boucle/:id',
    name: 'BoucleView',
    component: BoucleView,
    meta: {
      title: 'Golden Backyard - Résultats boucle'
    }
  },
  {
    path: '/challenge/:challenge_uuid',
    name: 'ChallengeView',
    component: ChallengeView,
    meta: {
      title: 'Golden Backyard - Résultats challenge'
    }
  },

]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'Golden Backyard';
  next();
});

export default router
